import React from 'react';
import { Box, Container, Grid, Skeleton, Stack } from '@mui/material';

import { LAYOUT_MAX_WIDTH } from '@/constants';

export const FooterSkeleton = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        pt: { xs: 8, md: 6 },
        pb: { xs: 10, md: 0 },
        borderTop: '1px solid',
        borderColor: 'divider',
        width: '100%',
        position: 'relative',
        zIndex: 10,
        px: { xs: 2, sm: 4, md: 8 },
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: LAYOUT_MAX_WIDTH, mx: 'auto' }}>
        <Grid container spacing={{ xs: 6, md: 4 }} justifyContent="space-between">
          {/* Brand & Description Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: { xs: 4, md: 0 } }}>
              <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width={120} height={32} sx={{ ml: 1 }} />
              </Box>
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="90%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </Box>
            <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </Grid>

          {/* Links Section Wrapper */}
          <Grid item xs={12} md={7}>
            <Stack
              direction="row"
              spacing={{ xs: 4, sm: 8, md: 12 }}
              justifyContent={{ xs: 'space-between', md: 'flex-end' }}
              sx={{ height: '100%' }}
            >
              {/* Quick Links Section */}
              <Box>
                <Skeleton variant="text" width={100} height={24} sx={{ mb: 2.5 }} />
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 1.5,
                    columnGap: 6,
                  }}
                >
                  {[...Array(6)].map((_, i) => (
                    <Skeleton key={i} variant="text" width={80} height={20} />
                  ))}
                </Box>
              </Box>

              {/* Support Links Section */}
              <Box>
                <Skeleton variant="text" width={100} height={24} sx={{ mb: 2.5 }} />
                <Box
                  sx={{
                    display: 'grid',
                    gap: 1.5,
                  }}
                >
                  {[...Array(4)].map((_, i) => (
                    <Skeleton key={i} variant="text" width={80} height={20} />
                  ))}
                </Box>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {/* Bottom Footer Section */}
        <Box sx={{ mt: 8, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Skeleton variant="text" width={200} height={20} />
            <Box sx={{ display: 'flex', gap: 3 }}>
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
